import { isPostalCode } from 'class-validator';
import type { PostalCodeLocale } from 'validator';
import { isPostalCodeLocales } from 'validator';
import { type IssueData, z } from 'zod';
import type { CountryCode } from '@/constants/country';
import { formatPostalCode } from '@/utils/currency/formatPostalCode';
const PostalCodeInvalidError: IssueData = {
  code: z.ZodIssueCode.custom,
  params: {
    i18n: 'custom.invalid_postal_code'
  }
};

/**
 * @remarks
 * validator パッケージの型定義の制約により、以下の型変換を使用:
 * - CountryCode から PostalCodeLocale への変換
 *   - 両者とも ISO 3166-1 alpha-2 形式だが型の互換性がないため
 * - isPostalCodeLocales の配列要素の型情報保持
 *   - validator の型定義制限により、includes メソッドの戻り値の型情報を維持するため
 */
const validatePostalCode = (postalCode: string, countryCode: CountryCode): boolean => {
  const code = countryCode.toUpperCase() as PostalCodeLocale;
  if (!isPostalCodeLocales.includes(code)) {
    return true; // サポート対象外の国コードの場合は検証をスキップ
  }
  return isPostalCode(postalCode, code);
};

/**
 * 郵便番号のバリデーションスキーマ
 */
export const postalCodeSchema = (countryCode: CountryCode) => z.string().superRefine((val, ctx) => {
  if (!validatePostalCode(val, countryCode)) {
    ctx.addIssue(PostalCodeInvalidError);
  }
}).transform(val => formatPostalCode(countryCode, val));